import React from "react";

export default function WeatherIcon(props) {
  let iconUrl = `http://shecodes-assets.s3.amazonaws.com/api/weather/icons/${props.icon}.png`;
  let size = `${props.size}`;
  return <img src={iconUrl} alt="weather icon" height={size} />;
}
